export default __webpack_public_path__ + "static/media/ico-prayer-room.1e0db081.svg";